import React from "react";
import { Typography } from "@mui/material";
import StageDetailsCard from "./stage-details-card";
import "./index.scss";

const ApprovalStageDetails = ({ approvalDetails, createdBy, substituteNameWithRole = false }) => {
  const { stages = [], isVendorGrn = false } = approvalDetails;

  const getRoleName = (stage) =>
    substituteNameWithRole ? (stage.stageRoleName || stage.stageName) : null;

  const getCurrentStageStatus = (stage, index) => {
    const { status, StageNumber = 0 } = stage;
    if (
      status === "approval_in_progress" &&
      StageNumber === 0 &&
      !isVendorGrn
    ) {
      const creatorDisplay = substituteNameWithRole ? null : createdBy;
      return {
        status: creatorDisplay? `Pending with creator : ${creatorDisplay}`
        : "Pending with creator",
        stageStatusClass: "warning",
        dateLabel: "",
        createdBy: substituteNameWithRole ? "" : (createdBy || ""),
      };
    } else if (status === "approval_in_progress") {
      const pendingDisplay = getRoleName(stage) || approvalDetails?.pendingWith || stage.stageName;
      return {
        status: `Pending With : ${pendingDisplay}`,
        stageStatusClass: "warning",
        dateLabel: "",
        createdBy: substituteNameWithRole ? "" : (createdBy || ""),
      };
    } else if (status === "approved") {
      const displayName = getRoleName(stage) || stage.approverName;
      return {
        status: `Approved By : ${displayName}`,
        name: displayName,
        stageStatusClass: "approved",
        dateLabel: "Approved On",
        createdBy: substituteNameWithRole ? "" : (createdBy || ""),
        comment: stage.approvalComments || "",
      };
    } else if (status === "rejected") {
      const displayName = getRoleName(stage) || stage?.rejectedByName || "";
      return {
        status: `Rejected By : ${displayName}`,
        name: displayName,
        stageStatusClass: "rejected",
        dateLabel: "Rejected On",
        comment: stage.rejectionReason || "",
        createdBy: substituteNameWithRole ? "" : (createdBy || ""),
      };
    } else if (status === "cancelled") {
      const displayName = getRoleName(stage) || stage?.cancelledByName || "";
      return {
        status: `Cancelled By : ${displayName}`,
        name: displayName,
        stageStatusClass: "rejected",
        dateLabel: "Cancelled On",
        createdBy: substituteNameWithRole ? "" : (createdBy || ""),
        stageName: "GRN Cancelled",
      };
    } else if (status === "hold") {
      const displayName = getRoleName(stage) || stage?.rejectedByName || "";
      return {
        status: `Hold By : ${displayName}`,
        name: displayName,
        stageStatusClass: "hold",
        dateLabel: "Hold On",
        createdBy: substituteNameWithRole ? "" : (createdBy || ""),
        stageName: "On hold",
        comment: stage.holdComments,
      };
    } else if (status === "reconsider") {
      const displayName = getRoleName(stage) || stage.rejectedByName || "";
      return {
        status: `Reconsider By : ${displayName}`,
        name: displayName,
        stageStatusClass: "reconsider",
        dateLabel: "Reconsider On",
        createdBy: substituteNameWithRole ? "" : (createdBy || ""),
        comment: stage?.reconsideredComments || "",
      };
    }
  };

  const stageDetails = stages;
  return (
    <div className="approval-stage-details-container">
      <div>
        <div className="details-header">
          <Typography className="title">Approval details</Typography>
        </div>

        <div className="approval-card-list">
          {stageDetails.map((stage, index) => {
            const updateStage = getCurrentStageStatus(stage, index);
            return (
              <StageDetailsCard
                stageDetails={{ ...stage, ...updateStage }}
                lastStage={stages.length === index + 1}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ApprovalStageDetails;
